import React, { useState } from 'react';
import { toast } from 'sonner';
import { Plus, UserPlus } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const INPUT = 'rounded-lg border border-slate-700 bg-slate-900 px-2 py-1 text-xs text-white outline-none focus:border-amber-500';

export const AddAuthorForm = ({ onAdded }) => {
  const { api } = useAuth();
  const [name, setName] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    try {
      const r = await api.post('/doctrine/authors', { name });
      toast.success(r.data.author.existing ? 'Ese autor ya estaba' : 'Autor agregado: Fidem está buscando sus artículos publicados');
      setName(''); onAdded(r.data.author.name);
    } catch (err) { toast.error(err.response?.data?.detail?.[0]?.msg || err.response?.data?.detail || 'No se pudo agregar'); }
  };
  return (
    <form data-testid="doctrine-add-author" onSubmit={submit} className="mb-2 flex flex-wrap gap-1.5">
      <input data-testid="doctrine-add-author-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Agregar autor (nombre y apellidos)" className={`${INPUT} min-w-[220px] flex-1`} />
      <button data-testid="doctrine-add-author-submit" disabled={name.trim().split(/\s+/).length < 2} className="flex items-center gap-1 rounded-lg bg-slate-700 px-2.5 py-1 text-xs disabled:opacity-50"><UserPlus className="h-3 w-3" />Agregar autor</button>
    </form>
  );
};

export const AddWorkForm = ({ author, onAdded }) => {
  const { api } = useAuth();
  const [f, setF] = useState({ title: '', year: '', publisher: '', kind: 'libro' });
  const [open, setOpen] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/doctrine/works', { author, title: f.title, year: f.year ? Number(f.year) : null, publisher: f.publisher, kind: f.kind });
      toast.success('Obra agregada: ya puedes subir tu ejemplar'); setF({ title: '', year: '', publisher: '', kind: 'libro' }); setOpen(false); onAdded();
    } catch (err) { toast.error(err.response?.data?.detail?.[0]?.msg || err.response?.data?.detail || 'No se pudo agregar'); }
  };
  if (!open) return <button data-testid="doctrine-add-work-btn" onClick={() => setOpen(true)} className="mb-3 flex items-center gap-1 text-xs text-amber-300 hover:underline"><Plus className="h-3 w-3" />Agregar una obra de {author}</button>;
  return (
    <form data-testid="doctrine-add-work" onSubmit={submit} className="mb-3 flex flex-wrap gap-1.5">
      <input data-testid="doctrine-work-title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} placeholder="Título" className={`${INPUT} min-w-[200px] flex-1`} />
      <input data-testid="doctrine-work-year" value={f.year} onChange={(e) => setF({ ...f, year: e.target.value.replace(/\D/g, '').slice(0, 4) })} placeholder="Año" className={`${INPUT} w-16`} />
      <input data-testid="doctrine-work-publisher" value={f.publisher} onChange={(e) => setF({ ...f, publisher: e.target.value })} placeholder="Editorial o revista" className={`${INPUT} w-40`} />
      <select data-testid="doctrine-work-kind" value={f.kind} onChange={(e) => setF({ ...f, kind: e.target.value })} className={INPUT}><option value="libro">libro</option><option value="capítulo">capítulo</option><option value="artículo">artículo</option></select>
      <button data-testid="doctrine-work-submit" disabled={f.title.trim().length < 3} className="rounded-lg bg-amber-500 px-2.5 py-1 text-xs font-semibold text-slate-950 disabled:opacity-50">Guardar</button>
    </form>
  );
};
